import React from 'react'
import {Link} from 'react-router-dom'
import ForgetForm from './../common/forget-form'

class Forget extends React.Component{
	render(){
		return(
			<div className="About">
				<section class="contact-img-area">
		            <div class="container">
		                <div class="row">
		                    <div class="col-md-12 text-center">
		                        <div class="con-text">
		                            <h2 class="page-title">forget</h2>
		                            <p><a href="#">Home <i class="fa fa-angle-right"></i></a> forget</p>
		                        </div>
		                    </div>
		                </div>
		            </div>
		        </section>
		        <section class="design-area home-five" >
				  	<div class="container">
				  		<ForgetForm />		   
				  	</div>
				</section>
			</div>
			)
	}
}
export default Forget;